import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import '../styles/CookieBanner.css';

const STORAGE_KEY = 'vitex.cookie-consent';

export default function CookieBanner() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  function accept(choice) {
    localStorage.setItem(STORAGE_KEY, choice);
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label={t('cookieBanner.title')}>
      <div className="cookie-banner-inner">
        <div className="cookie-banner-text">
          <p className="cookie-banner-title">{t('cookieBanner.title')}</p>
          <p className="cookie-banner-desc">
            {t('cookieBanner.message')}{' '}
            <Link to="/cerez-politikasi">{t('cookieBanner.learnMore')}</Link>
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button className="cookie-btn-necessary" onClick={() => accept('necessary')}>
            {t('cookieBanner.necessaryOnly')}
          </button>
          <button className="cookie-btn-accept" onClick={() => accept('all')}>
            {t('cookieBanner.acceptAll')}
          </button>
        </div>
      </div>
    </div>
  );
}
